import {
    useMemo,
} from 'react'
import {
    Link,
} from 'react-router-dom'
import clsx from 'clsx'

import useSelectedTab from '../hooks/useSelectedTab'
import useAllowedLinks from '../hooks/useAllowedLinks'
import useStyles from './Menu.style'
import MenuDropdown from './MenuDropdown'

const Menu = () => {
    const {
        classes,
    } = useStyles()

    const activeTab = useSelectedTab()
    const allowedLinks = useAllowedLinks()

    const selectedId = useMemo(() => {
        return ('id' in activeTab) ? activeTab.id : ''
    }, [activeTab])

    return (
        <div
            className="h-full"
        >
            <div className={clsx(
                classes.logoContainer,
                selectedId === 'dashboard' && classes.activeLink,
            )}
            >
                <Link
                    to="/"
                    className={classes.logoLink}
                >
                    <img
                        className={classes.logo}
                        src="assets/images/logos/logo_negative.svg"
                        alt="logo"
                    />
                </Link>
            </div>

            {allowedLinks.map(({
                id,
                icon: Icon,
                links,
                className,
            }) => {
                return (
                    <div
                        key={`menu-item-${id}`}
                        className={clsx(
                            classes.item,
                            selectedId === id && classes.activeLink,
                        )}
                    >
                        <Icon
                            className={clsx(
                                classes.icon,
                                classes[className],
                            )}
                        />
                        {selectedId !== id && (
                            <MenuDropdown links={links} />
                        )}
                    </div>
                )
            })}

        </div>
    )
}

export default Menu
